import { useAppSelector } from '../../store.model';
import { getMyWorkspaceSelector } from '../selectors/StoerkId.selectors';

/** be PRO mean have a workspace active */
function useCloudConnectPro() {
  const workspace = useAppSelector(getMyWorkspaceSelector);
  const isPro = workspace?.quota.devices && workspace?.quota.devices > 0;
  return isPro;
}

export default useCloudConnectPro;
